import api from './api';

export type ChargesType = 'ercap' | 'nuclear_energy_settlement' | string;

export interface GetChargesParams {
  year: number;
  month: number; // 1-12
  type: ChargesType;
  unitId?: number;
}

export interface ChargeItem {
  month: number;
  year?: number;
  unitId?: number;
  unitName: string;
  value: any;
}

function normalizeChargesResponse(data: any): ChargeItem[] {
  const list = Array.isArray(data)
    ? data
    : Array.isArray(data?.data)
      ? data.data
      : Array.isArray(data?.charges)
        ? data.charges
        : data && typeof data === 'object'
          ? [data]
          : [];

  const out: ChargeItem[] = [];

  for (const el of list) {
    // Formato real do back (exemplo do usuário):
    // { month: 3, price: 2494, unit_id: 271, unit_name: "Afrib", year: 2026 }
    const month = Number(el?.month ?? el?.mes ?? el?.m);
    if (!Number.isFinite(month)) continue;

    const unitName = String(el?.unit_name ?? el?.unitName ?? el?.unit?.name ?? '').trim();
    const unitId = el?.unit_id ?? el?.unitId ?? el?.unit?.id;
    const year = el?.year ?? el?.ano ?? undefined;

    const value =
      el?.price ?? // campo do back
      el?.value ??
      el?.valor ??
      el?.amount ??
      el?.val;

    out.push({
      month,
      year: year != null ? Number(year) : undefined,
      unitId: unitId != null ? Number(unitId) : undefined,
      unitName: unitName || '-',
      value,
    });
  }

  return out;
}

const getCharges = {
  get: async function (user: any, params: GetChargesParams) {
    let ret: any = { valid: false };

    await api
      .get('charges', {
        headers: { Authorization: user.token },
        params: {
          year: params.year,
          month: params.month,
          type: params.type,
          // opcional: mantém filtro por unidade (nomes alternativos por segurança)
          ...(params.unitId ? { unit_id: params.unitId, unit: params.unitId } : {}),
        },
      })
      .then((resp) => {
        ret = { valid: true, data: normalizeChargesResponse(resp?.data) };
      })
      .catch((err) => {
        ret = {
          valid: false,
          data: err?.response?.data,
          message: err?.response?.data?.message || err?.message || 'Erro ao carregar charges.',
        };
      });

    return ret;
  },
};

export type UploadType = 'charges' | 'generic';

export interface UploadChargesPayload {
  file: File | Blob;
  year?: number | string; // ano (opcional)
  month?: number | string; // mês (opcional)
  type?: UploadType | string; // tipo de upload
  overwrite?: boolean; // sobrescrever dados existentes
}

const uploadCharges = {
  upload: async function (user: any, payload: UploadChargesPayload) {
    let ret: any = { valid: false };

    const formData = new FormData();
    formData.append('file', payload.file);  
    if (payload.year != null) formData.append('year', String(payload.year));
    if (payload.month != null) formData.append('month', String(payload.month));
    if (payload.type) formData.append('type', String(payload.type));
    if (payload.overwrite != null) formData.append('overwrite', String(payload.overwrite));

    await api
      .post('/charges', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: user.token,
        },
      })
      .then((resp) => {
        ret = { valid: true, data: resp.data };
      })
      .catch((err) => {
        ret = {
          valid: false,
          data: err?.response?.data,
          message: err?.response?.data?.message || err?.message || 'Erro ao enviar arquivo.',
        };
      });

    return ret;
  },
};

export default {
  getCharges,
  uploadCharges,
};

